import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "./Services.scss";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { normalizeUrl } from "../utils/normalizeUrl";

const Services = ({ services = [], text }) => {
  const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const sliderRef = useRef(null);

  if (!services || services.length === 0) {
    return null;
  }

  const nextService = () => {
    if (
      sliderRef.current &&
      sliderRef.current.slickNext &&
      currentServiceIndex < services.length - 1
    ) {
      setIsTransitioning(true);
      sliderRef.current.slickNext();
    }
  };

  const prevService = () => {
    if (
      sliderRef.current &&
      sliderRef.current.slickPrev &&
      currentServiceIndex > 0
    ) {
      setIsTransitioning(true);
      sliderRef.current.slickPrev();
    }
  };

  const goToService = (index) => {
    if (
      sliderRef.current &&
      sliderRef.current.slickGoTo &&
      index >= 0 &&
      index < services.length
    ) {
      setIsTransitioning(true);
      sliderRef.current.slickGoTo(index);
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 300,
    autoplay: false,
    autoplaySpeed: 3000,
    waitForAnimate: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false, // Désactive les flèches par défaut
    beforeChange: (oldIndex, newIndex) => {
      setCurrentServiceIndex(newIndex);
    },
    afterChange: (index) => {
      // Délai pour permettre à l'animation de se terminer
      setTimeout(() => {
        setIsTransitioning(false);
      }, 300);
    },
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  return (
    <section className="section services-block">
      <div className="inner">
        <div className="services-content">
          <div className="services-text m-padding">
            <div className="services-text-inner">
              <div
                dangerouslySetInnerHTML={{
                  __html: text,
                }}
              />
            </div>
          </div>
          <div className="services-image-carousel">
            <div className="services-image">
              <div className="image-container">
                <img
                  src={
                    services[0]?.image?.localFile?.childImageSharp?.fluid?.src
                  }
                  alt={services[0]?.image?.altText || "Service"}
                  className={`service-image active`}
                />
                {/*services.map((service, index) => (
                  <img
                    key={index}
                    src={service?.image?.localFile?.childImageSharp?.fluid?.src}
                    alt={service?.image?.altText || "Service"}
                    className={`service-image ${
                      index === currentServiceIndex ? "active" : ""
                    } ${isTransitioning ? "transitioning" : ""}`}
                  />
                ))*/}
              </div>
            </div>
            <div className="services-cards">
              <div className="services-carousel">
                <Slider ref={sliderRef} {...settings}>
                  {services.map((service, index) => (
                    <div className="service-card" key={service.title}>
                      <div className="service-card-image">
                        <img
                          src={
                            service?.image?.localFile?.childImageSharp?.fluid
                              ?.src
                          }
                          alt={service?.image?.altText || "Service"}
                        />
                      </div>
                      <div className="service-card-inner">
                        <div className="service-card-header">
                          <h3>{service?.title}</h3>
                          <p>{service?.description}</p>
                        </div>
                        {service?.link?.url && service?.link?.title && (
                          <a
                            href={normalizeUrl(service?.link?.url)}
                            className="service-btn"
                          >
                            {service?.link?.title}
                          </a>
                        )}
                      </div>
                    </div>
                  ))}
                </Slider>

                {/* Boutons de navigation personnalisés */}
                <div className="custom-navigation">
                  <button
                    className={`custom-nav-btn prev ${
                      currentServiceIndex === 0 ? "disabled" : ""
                    }`}
                    onClick={prevService}
                    disabled={currentServiceIndex === 0}
                    aria-label="Service précédent"
                  >
                    <ArrowLeftIcon
                      style={{
                        width: "18px",
                      }}
                    />
                  </button>
                  <button
                    className={`custom-nav-btn next ${
                      currentServiceIndex === services.length - 1
                        ? "disabled"
                        : ""
                    }`}
                    onClick={nextService}
                    disabled={currentServiceIndex === services.length - 1}
                    aria-label="Service suivant"
                  >
                    <ArrowRightIcon
                      style={{
                        width: "18px",
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
